import * as React from 'react';

import Box from '@mui/material/Box';

import ImgRotation1 from '../../assets/rotation-1.png';
import ImgRotation2 from '../../assets/rotation-2.png';
import ImgRotation3 from '../../assets/rotation-3.png';
import ImgRotation4 from '../../assets/rotation-4.png';

export default function Rotation(){
    const dotColors = ['#172554', '#B0B4C4', '#B0B4C4', '#172554'];
    const rotations = [
        {
            title: 'Rotation 1',
            shadowClass: "shadow-blue",
            image: ImgRotation1,
            imageClass: 'icon-location',
            description: '',
        },
        {
            title: 'Rotation 2',
            shadowClass: "shadow-blue",
            image: ImgRotation2,
            imageClass: 'icon-binoculars',
            description: '',
        },
        {
            title: 'Rotation 3',
            shadowClass: "shadow-blue",
            image: ImgRotation3,
            imageClass: 'icon-location',
            description: '',
        },
        {
            title: 'Rotation 4',
            shadowClass: "shadow-blue",
            image: ImgRotation4,
            imageClass: 'icon-binoculars',
            description: '',
        },
        // ...
    ];

    return (
        <Box className='wrapper rotation'>
            <h2 className='section-title'>Experience Diverse Rotational Opportunities</h2>
            {/*
            <Box className="flow-chart">
                <Box className="total">2 Years</Box>
                <Box className="rotation-wrapper">
                    <Box className="rotation-item">
                        <p className="desc">Rotation 1 (6 Months)</p>
                    </Box>
                    <Box className="rotation-item">
                        <p className="desc">Rotation 2 (6 Months)</p>
                    </Box>
                    <Box className="rotation-item">
                        <p className="desc">Rotation 3 (6 Months)</p>
                    </Box>
                    <Box className="rotation-item">
                        <p className="desc">Rotation 4 (6 Months)</p>
                    </Box>
                </Box>
            </Box>
            */}
            <Box className="years-milestone">
                <div className="years-milestone__line" />
                    {dotColors.map((color, index) => (
                        <div className="years-milestone__dot-wrap" key={index}>
                            <span className="years-milestone__dot" style={{ backgroundColor: color }}/>
                        </div>
                    ))}
                <div className="years-milestone__label">2 years</div>
            </Box>

            <Box className="rotation-container">
                {rotations.map((rotation) => (
                    <div
                        key={rotation.title}
                        className={`rotation-card ${rotation.shadowClass}`}
                    >
                        <span className="rotation-icon">
                            <img src={rotation.image} alt={rotation.title} className={rotation.imageClass} />
                        </span>

                        <p className="rotation-title">{rotation.title}</p>
                        {/*<p className="rotation-description">{rotation.description}</p>*/}
                    </div>
                ))}
            </Box>

            <p className="desc">As an FMA, you will undertake four thoughtfully designed rotations. Each challenges you to build depth; together, they broaden your exposure across the Finance spectrum and sharpen your edge in the technologies shaping Finance.</p>
            <Box className="item">
                <h4 className="title">Accounting & Financial Reporting</h4>
                <Box className="desc">
                    Prepare accurate and timely quarterly and annual group reports and financial statements, offering comprehensive insights into the company's financial performance.
                </Box>
            </Box>
            <Box className="item">
                <h4 className="title">Business Assurance</h4>
                <Box className="desc">
                    Drive efficiency and effectiveness in governance, risk management, and internal controls while managing risk and compliance with integrity through continuous improvement.
                </Box>
            </Box>
            <Box className="item">
                <h4 className="title">Business Planning & Analysis</h4>
                <Box className="desc">
                    Participate in the management reporting process, budgeting, and forecasting cycles, and perform key analyses on the financial performance of business segments at regional level.
                </Box>
            </Box>
            <Box className="item">
                <h4 className="title">Controllership</h4>
                <Box className="desc">
                    Collaborate with country finance and business teams to spearhead pivotal projects and new developments, enhancing financial processes and reporting quality across the group, and driving strategic insights.
                </Box>
            </Box>
            <Box className="item">
                <h4 className="title">Corporate Treasury</h4>
                <Box className="desc">
                    Engage in managing the liquidity for Sea's businesses, supporting the company's long-term strategy and growth opportunities.
                </Box>
            </Box>
            <Box className="item">
                <h4 className="title">Finance Business Analytics</h4>
                <Box className="desc">
                    Enhance finance operations by optimizing reporting metrics and frameworks through technology, leveraging data analytics to gain strategic financial insights.
                </Box>
            </Box>
            <Box className="item">
                <h4 className="title">Finance Process & Systems Innovation</h4>
                <Box className="desc">
                    Pioneer transformative initiatives to achieve finance excellence by adopting technology and automation, enhancing efficiency and productivity.
                </Box>
            </Box>
            <Box className="item">
                <h4 className="title">Regional Tax</h4>
                <Box className="desc">
                    Optimize tax strategies and ensure compliance with tax regulations, contributing to the company's overall financial efficiency.
                </Box>
            </Box>




            
        </Box>
    );
}